module.exports = __webpack_public_path__ + "img/steel-6.2195b79a.jpg";